import { CriticalError } from '@core/services/critical-error';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { logging } from '@utils/logging';

export class LogMissingTranslationHandler implements MissingTranslationHandler {
  constructor(private readonly criticalErrorService: CriticalError) {}

  handle(params: MissingTranslationHandlerParams): string {
    // Log missing translation keys only when not in panic mode.
    // Panic mode is activated if a JS module or translation file fails to load,
    // which triggers an app reload. Since the reload is not immediate,
    // this handler may still be called, resulting in irrelevant missing translation errors.
    if (!this.criticalErrorService.panicMode) {
      // Wrapped in Error object to capture stack trace; grouped by key, not by the call path
      logging.error(new Error(`Missing translation for key: '${params.key}'`), undefined, {
        fingerprint: ['missing-translation', params.key],
        tags: { 'translation.key': params.key }
      });
    }

    return params.key;
  }
}
